/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * 吐槽下代驾... 我 ^%@!%$*
 * @author linkFly(jianglai@didichuxing.com)
 */

 // 代驾可调用的 API 文档： http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=38710326


import { isAndroid, isIOS, invokeInTurn } from '../util'
import { daijiaConfig } from '../config'
import callIOS from './ios'
import callAndroid from './android'

let DDBridgeDaijiaDriver = {}

const defaultFn = function () { }

function call(method, param = {}, callback = defaultFn) {
  invokeInTurn(_call, arguments)
}

function _call(method, param = {}, callback = defaultFn) {
  if (isAndroid) {
    callAndroid(method, param, callback)
  } else {
    callIOS(method, param, callback)
  }
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function wrapBridgeFn(name, conf, args) {
  return function (param = {}, callback = defaultFn) {

    if (arguments.length === 1 && typeof param === 'function') {
      callback = param
      param = {}
    }

    let method = conf ? conf.fn : name
    let prepare = conf ? conf.prepare : null

    // 是否支持该方法判断
    // 暂时缺省

    if (prepare && typeof prepare === 'function') {
      call.apply(null, prepare.apply(null, args));
    } else if (name) {
      call(method, param, callback)
    }

  }
}

/**
 * 司机端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initDriverBaseCall(DDBridge) {
  DDBridge.call = function (method, param = {}, callback = defaultFn) {

    let conf = daijiaConfig[method],
      args = Array.prototype.slice.call(arguments, 0),
      bridgeFn = wrapBridgeFn(method, conf, args)

    if ((!callback || callback === defaultFn) && typeof param === 'function') {
      callback = param
      param = {}
    }

    return bridgeFn(param, callback)
  }
}

initDriverBaseCall(DDBridgeDaijiaDriver)

export { DDBridgeDaijiaDriver }



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgedaijiadriver/index.js